import styles from "./styles.module.scss";
import ErrorTippy from "../../../components/Programs/ErrorTippy";
import { useFormContext } from "react-hook-form";
import React from "react";
import ToolTip from "app/routes/Scheduling/ToolTip";

const TaxItem = ({
  tagTitle,
  fieldName,
  defaultValue = null,
  isEditable = true,
  showInput = true,
  highField = false,
  error = null,
  hideLabel = false,
  longField = false,
  placeholder = null,
  isNumberOnly = null,
  tooltipText = null,
  checkValue=null,
  description = null,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const registerProps =  register(fieldName);

  const inputStyling = isEditable
    ? styles.input_container
    : styles.input_container_not_editable;

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9\b]+$/;

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  return (
    <div className={styles.container}>
       <input
        {...register('tax_option')}
        type="radio"
        name="tax_option"
        value={checkValue}
        className={styles.custom_radio_input}
      />
    <div className={styles.option_container}>
      {!hideLabel && (
        <div className={styles.select_container}>
          <p
            className={`${styles.tag} ${
              highField ? styles.high_field_tag : ""
            }`}
          >
            {tagTitle}
          </p>
          {tooltipText && <ToolTip text={tooltipText} />}
        </div>
      )}
      {description && <div className={styles.description}> {description} </div>}
      <div
        className={`${
          error
            ? styles.error_line_container
            : styles.line_container
        } ${highField ? styles.p_13_8 : styles.p_10} `}
      >
       {showInput && (
         <ErrorTippy placement="top-end" errors={errors} field_name={fieldName}>
          <input
            defaultValue={defaultValue}
            data-cy={fieldName}
            data-testid={fieldName}
            placeholder={placeholder}
            className={`${inputStyling} ${
              longField ? styles.long_field : ""
            }`}
            {...registerProps}
            readOnly={!isEditable}
            onKeyPress={isNumberOnly ? handleKeyPress : null}
          />
        </ErrorTippy>
       )
        }
      </div>
    </div>
    </div>
  );
};

export default TaxItem;
